import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import Button from "../../atoms/Button";
import NoData from "../../atoms/NoData";
import CardTables from "../../atoms/CardTables";
import EmpresasAdminSearch from "../empresasAdmin/EmpresasAdminSearch";

const TableEmpresasContador = ({ data, loading, filters, setFilters }) => {
    const navigate = useNavigate();

    const handlePush = (id) => {
        navigate(`/clientes/empresas/${id}`)
    };

    const columns = [
        { name: "Empresa", cell: row => (
            <div className="flex flex-col">
                <p> {row.name}  </p>
                <p> Cliente: {row.clientInfo.name} </p>
            </div>
            ),
        },
        { name: "Regimen", cell: row =>(
            <div className="flex flex-col">
                <p> {row?.type === "LegalEntitie" ? "Persona moral" : "Persona fisica"}</p>
            </div>
        )},
        { name: "Acciones", cell: row => (
            <div className="flex flex-col">
                <Button text={<FaArrowRight size={22} />} bgColor="orange" width="w-10" onClick={()=> handlePush(row.id)} />
            </div>
        ), width:"15%"},
    ];

    const columnsResponsive = [
        { name: "Nombre", cell: row => (
            <div
                className="flex flex-col"
                onClick={()=> handlePush(row.id)}
            >
                <p> {row?.name} </p>
                <p> {row?.type === "LegalEntitie" ? "Persona moral" : "Persona fisica"} </p>
                <p> Cliente: {row.clientInfo?.name || "rl no encontrado"} </p>
            </div>
        )}
    ];

    return(
        <CardTables>
            {filters && setFilters && (
                <EmpresasAdminSearch filters={filters} setFilters={setFilters} />
            )}
            <div className="block md:hidden">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    onRowClicked={(row) => handlePush(row.id)}
                    noDataComponent={<NoData/>}
                    pagination
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                />
            </div>
        </CardTables>
    );
};

export default TableEmpresasContador;